import { v4 as uuidv4 } from 'uuid';

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
};

const setCookie = (name: string, value: string, days: number): void => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

const getOrCreateDeviceId = (): string => {
  const localStorageKey = 'express_device_id';
  const cookieKey = 'express_device_id';

  let deviceId = localStorage.getItem(localStorageKey);

  if (!deviceId) {
    deviceId = getCookie(cookieKey);
  }

  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem(localStorageKey, deviceId);
    setCookie(cookieKey, deviceId, 365);
  }

  return deviceId;
};

export default getOrCreateDeviceId;
